const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const replaceWhatsappStyle = (
  text: string,
  delimiter: string,
  replacement: (content: string) => string,
) => {
  const escapedDelimiter = escapeRegExp(delimiter)
  const escapedDelimiterCharacter = escapeRegExp(delimiter[0])
  const pattern = new RegExp(
    `${escapedDelimiter}([^\\s${escapedDelimiterCharacter}](?:[^${escapedDelimiterCharacter}\\n]*?[^\\s${escapedDelimiterCharacter}])?)${escapedDelimiter}`,
    'g',
  )

  return text.replace(pattern, (_match, content: string) => replacement(content))
}

/**
 * Applies WhatsApp's inline formatting rules to already escaped HTML text.
 * A format marker cannot be followed or preceded by whitespace.
 */
export const formatWhatsappText = (text: string) => {
  let content = text.replace(/\r\n/g, '\n').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  content = content.replace(
    /```([^\s`](?:[^`\n]*?[^\s`])?)```/g,
    '<span class="font-mono">$1</span>',
  )
  content = replaceWhatsappStyle(
    content,
    '*',
    (value) => `<strong class="font-semibold">${value}</strong>`,
  )
  content = replaceWhatsappStyle(content, '_', (value) => `<em class="italic">${value}</em>`)
  content = replaceWhatsappStyle(content, '~', (value) => `<s class="line-through">${value}</s>`)
  content = content.replace(
    /`([^\s`](?:[^`\n]*?[^\s`])?)`/g,
    '<code class="bg-gray-100 px-1 rounded font-mono text-pink-600">$1</code>',
  )

  return content
}
